var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"developer-register-program"},[(_vm.form)?_c('s-form-container',{attrs:{"form":_vm.form}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }